import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import DeployLegalFooter from "../../components/deploy/DeployLegalFooter";

/**
 * RD-0731 — Terms summary (full detail in docs/deploy/legal/terms-of-service.md).
 */
function DeployTermsPage() {
  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployTermsPage] mount`);
  }, []);

  useEffect(() => {
    console.log(`[${new Date().toISOString()}] [DeployTermsPage] render`);
  });

  return (
    <>
      <SEO
        title="Limelite Deploy — Terms of Service"
        description="Acceptable use, suspension, EUR billing, and EU workload summary for RivieraDeploy."
        keywords="Limelite Deploy, terms, acceptable use, EUR"
        url="/limelite/deploy/terms"
      />
      <div className="bg-black text-silver-light min-h-[calc(100vh-4rem)] px-4 py-12">
        <div className="max-w-3xl mx-auto space-y-8">
          <p className="text-sm uppercase tracking-widest text-lime-500 text-xs uppercase tracking-widest">Limelite Deploy</p>
          <h1 className="text-3xl font-serif font-medium">Terms of Service (summary)</h1>
          <p className="text-silver-medium text-sm">
            This page summarizes how the product operates. Authoritative legal text should be finalized with counsel before
            broad marketing.
          </p>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Service</h2>
            <p>
              Limelite Deploy exposes a hosted MCP control plane and automation to deploy your code to AWS (default region{" "}
              <span className="text-silver-light">eu-north-1</span>). Subscription and usage are billed in{" "}
              <span className="text-silver-light">EUR</span> via Stripe.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Acceptable use</h2>
            <p>You must not use the service for illegal activity, to infringe others&apos; rights, or to attack third parties.</p>
            <p>
              You remain responsible for your repositories, licenses, secrets hygiene, and outbound traffic from workloads we
              provision for you.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Suspension and termination</h2>
            <p>
              We may suspend MCP access, pause provisioning, stop instances, or close accounts for abuse, non-payment, legal
              requirements, or platform safety. Automated guards (rate limits, spend caps, anomaly detection) exist to reduce
              harm — see the dashboard and runbooks.
            </p>
          </section>

          <section className="space-y-3 text-sm text-silver-medium">
            <h2 className="text-lg text-silver-light font-medium">Privacy &amp; data</h2>
            <p>
              GDPR export, deletion, and DPA commitments are documented separately. Infrastructure defaults target EU residency
              for customer workloads as described in deployment docs.
            </p>
          </section>

          <p className="text-xs text-gray-600">
            Long-form notes: <code className="text-gray-500">docs/deploy/legal/terms-of-service.md</code>
          </p>

          <div className="pt-4">
            <Link to="/limelite/deploy" className="text-sm text-silver-medium hover:text-silver-light underline">
              Back to Limelite Deploy
            </Link>
          </div>

          <DeployLegalFooter />
        </div>
      </div>
    </>
  );
}

export default DeployTermsPage;
